import { get, writable } from 'svelte/store';

import { isTestUser } from 'src/helpers/user_helpers';

const STORAGE_KEY = 'event_log_v2_enabled';

const readInitialValue = (): boolean => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === 'true') {
			return true;
		}
		if (stored === 'false') {
			return false;
		}
	} catch {
		// localStorage may be unavailable
	}
	return isTestUser();
};

export const eventLogV2Enabled = writable<boolean>(readInitialValue());

eventLogV2Enabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isEventLogV2Enabled = (): boolean => get(eventLogV2Enabled);
